import { FLUID_POS_LERP_ACTIVE, FLUID_POS_LERP_IDLE } from '../config';

const reducedMotionMedia = (typeof window !== 'undefined' && typeof window.matchMedia === 'function')
  ? window.matchMedia('(prefers-reduced-motion: reduce)')
  : null;

let prefersReducedMotion = !!(reducedMotionMedia && reducedMotionMedia.matches);

if (reducedMotionMedia) {
  const onReducedMotionChange = (event: MediaQueryListEvent) => {
    prefersReducedMotion = !!event.matches;
  };
  if (typeof reducedMotionMedia.addEventListener === 'function') {
    reducedMotionMedia.addEventListener('change', onReducedMotionChange);
  } else if (typeof (reducedMotionMedia as unknown as { addListener?: unknown }).addListener === 'function') {
    (reducedMotionMedia as unknown as { addListener: (cb: (e: MediaQueryListEvent) => void) => void }).addListener(onReducedMotionChange);
  }
}

export function isReducedMotion(): boolean {
  return prefersReducedMotion;
}

export function getReducedMotionDuration(durationMs: number, minMs = 120): number {
  if (!prefersReducedMotion) return durationMs;
  return Math.max(minMs, durationMs * 0.55);
}

export function getHomePosLerp(activeHighlight: boolean): number {
  if (!prefersReducedMotion) {
    return activeHighlight ? FLUID_POS_LERP_ACTIVE : FLUID_POS_LERP_IDLE;
  }
  return activeHighlight ? 0.32 : 0.24;
}
